import React, { useState } from "react";
import ProgramDetail from "../../Components/konsentrasi/detailKonsentrasi";
import NavbarThree from "../../Components/Navbar/navbarThree";
import Footer from "../../Components/Footer";

const DetailKonsenPages = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <>
      <NavbarThree isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />

      <div className="pt-16">
        <ProgramDetail />
      </div>

      <Footer />
    </>
  );
};

export default DetailKonsenPages;
